import { TuiInputNumber, TuiTooltip } from '@taiga-ui/kit';
import {
  TuiHint,
  TuiInput,
  TuiIcon,
  TuiTextfield,
  TuiLabel,
} from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { WorkflowFormFieldInputNumber } from '@features/requests/request-form/components/request-form-workflows/types';

@Component({
  selector: 'x-input-number-field',
  imports: [
    TuiTextfield,
    TuiLabel,
    ReactiveFormsModule,
    TuiInputNumber,
    TuiHint,
    TuiInput,
    TuiIcon,
    TuiTooltip,
  ],
  templateUrl: './input-number-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class InputNumberFieldComponent {
  field = input.required<WorkflowFormFieldInputNumber>();
  control = input.required<FormControl<number | null>>();
}
